import { render, staticRenderFns } from "./BaruManageMember.vue?vue&type=template&id=567b9330&"
import script from "./BaruManageMember.vue?vue&type=script&lang=js&"
export * from "./BaruManageMember.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports